export default __webpack_public_path__ + "static/media/red-cross.d24ab790.png";